import React from 'react';
import { useSelector } from 'react-redux';

import Reply from '../comment-reply';

export const Replies = ({ comment, scrollContainer, highlightStyle }) => {
  const videoPlayer = useSelector(state => state.video_player);
  const {
    video: { comments_enabled: commentsEnabled },
  } = videoPlayer;
  const replyElements =
    comment.replies &&
    comment.replies.map(reply => {
      return (
        <Reply
          key={reply.id}
          reply={reply}
          highlightStyle={highlightStyle}
          scrollContainer={scrollContainer}
        />
      );
    });

  return (
    commentsEnabled &&
    replyElements &&
    Boolean(replyElements.length) && <>{replyElements}</>
  );
};
